module.exports = __webpack_public_path__ + "img/mpesa.b1447c08.png";